import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'library' },
  {
    path: 'library',
    title: 'Image library',
    loadComponent: () => import('./features/library/library.component').then((m) => m.LibraryComponent)
  },
  {
    path: 'compare',
    title: 'Compare',
    loadComponent: () => import('./features/compare/compare.component').then((m) => m.CompareComponent)
  },
  {
    path: 'results',
    title: 'Past runs',
    loadComponent: () => import('./features/results/results-list.component').then((m) => m.ResultsListComponent)
  },
  {
    path: 'results/:id',
    title: 'Analysis result',
    loadComponent: () =>
      import('./features/results/result-detail.component').then((m) => m.ResultDetailComponent)
  },
  { path: '**', redirectTo: 'library' }
];
